
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  updateGradientActivePercent,
  useMouseEvents
} from "@/components/Reusable/CustomInputs/3rdPartyWrappers/Gradient/helpers";
import { GradientPoint as GradientPoint_ } from "@/types/colors";
import Icon from "@/components/UI/Icon.vue";

type Positions = { startX: number; offsetX: number };
@Component({
  components: { Icon }
})
export default class GradientPoint extends Vue {
  @Prop()
  point!: GradientPoint_;

  @Prop()
  activePointIndex!: number;

  @Prop()
  index!: number;

  @Prop()
  width!: number;

  dragging = false;

  @Prop()
  changeActivePointIndex!: Function;

  @Prop()
  updateGradientLeft!: Function;

  @Prop()
  removePoint!: Function;

  mouseEvents: (event: MouseEvent) => void = () => {};

  mounted() {
    this.mouseEvents = useMouseEvents(
      this.mouseDownHandler,
      this.mouseMoveHandler,
      this.mouseUpHandler
    );
  }

  get activeClassName() {
    return {
      active: this.activePointIndex === this.index,
      dragging: this.dragging
    };
  }

  get pointStyle() {
    return { left: `${this.point.left * (this.width / 100) - 8}px` };
  }

  get percentage() {
    const percentage = Math.round(this.point.left);
    return `${percentage}%`;
  }

  onClick(event: MouseEvent) {
    if (event.shiftKey) {
      this.removePoint(this.index);
    }
  }

  mouseDownHandler(event: MouseEvent) {
    const startX = event.pageX;
    const startY = event.pageY;
    const target = event.target as HTMLElement;
    const parent = target.parentNode as HTMLElement;
    const containerX = parent.getBoundingClientRect().x;

    this.changeActivePointIndex(this.index);
    const offsetX = startX - containerX;

    this.updateGradientLeft(this.point.left, this.index, "onStartChange");
    this.$emit("pointStart");
    this.dragging = true;

    return {
      startX,
      startY,
      offsetX
    };
  }

  changeObjectPositions(event: MouseEvent, { startX, offsetX }: Positions) {
    const pageX = event.pageX;
    const moveX = pageX - startX;
    offsetX += moveX;
    // update point percent
    const left = updateGradientActivePercent(offsetX, this.width);

    return {
      positions: {
        offsetX,
        startX: pageX
      },
      left
    };
  }

  mouseMoveHandler(event: MouseEvent, { startX, offsetX }: Positions) {
    event.preventDefault();

    const { positions, left } = this.changeObjectPositions(event, {
      startX,
      offsetX
    });

    this.updateGradientLeft(left, this.index, "onChange");

    return positions;
  }

  mouseUpHandler(event: MouseEvent, { startX, offsetX }: Positions) {
    event.preventDefault();

    const { positions, left } = this.changeObjectPositions(event, {
      startX,
      offsetX
    });

    this.updateGradientLeft(left, this.index, "onEndChange");

    this.$emit("pointEnd");
    this.dragging = false;

    return positions;
  }
}
